import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  coupons: [],
  templates: [],
  guestOffers: [],
  loading: false,
  error: null,
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    setCoupons: (state, action) => {
      state.coupons = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setGuestOffers: (state, action) => {
      state.guestOffers = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCoupons, setTemplates, setGuestOffers, setLoading, setError } = couponSlice.actions;
export const selectCouponData = (state) => state.coupon;
export default couponSlice.reducer;
